import type {NegotiationLineChange} from '@afriex/core/utils';
import {getCorridorKey, getFeeAmountKind} from '@afriex/core/utils';

import {AmountInput, PercentageInput} from '@/components';
import type {AfriexCurrencyCode} from '@/types';

import {askText} from './negotiationAnswerReducer';
import type {NegotiationAnswer} from './useNegotiationAnswer';

type CounterRateInputProps = {
  line: NegotiationLineChange;
  answer: NegotiationAnswer;
};

/**
 * The box Afriex types its price into: a percentage for a percentage corridor,
 * a flat amount in the corridor's own currency for a flat one.
 */
const CounterRateInput = ({line, answer}: CounterRateInputProps) => {
  const key = getCorridorKey(line.corridor);
  const error = answer.validator.lineErrors()[key];
  const setText = (text: string) =>
    answer.dispatch({type: 'SET_TEXT', key, text});

  return (
    <div className="w-40 py-2">
      {getFeeAmountKind(line.defaultAmount) === 'percent' ? (
        <PercentageInput
          value={answer.state.texts[key] ?? ''}
          onValueChange={setText}
        />
      ) : (
        // Seeded once: the box keeps what is typed, and an emptied box is
        // reported through onClear.
        <AmountInput
          value={{
            amount: Number(askText(line)),
            currency: line.defaultAmount?.currencyCode as AfriexCurrencyCode,
          }}
          fixedCurrency={line.defaultAmount?.currencyCode}
          onChange={({amount}) => setText(String(amount))}
          onClear={() => setText('')}
        />
      )}
      {error ? (
        <p className="mt-1 whitespace-normal text-xs text-red-600 dark:text-red-400">
          {error}
        </p>
      ) : null}
    </div>
  );
};

export default CounterRateInput;
